<template>
	<component
		:is="tag"
		ref="container"
		:style="style"
		:aria-hidden="!active"
		:aria-expanded="active"
		@transitionend="onTransitionEnd"
	>
		<slot v-if="!hidden" />
	</component>
</template>

<script>
export default {
	props: {
		active: Boolean,
		duration: {
			type: Number,
			default: 500,
		},
		tag: {
			type: String,
			default: 'div',
		},
		useHidden: {
			type: Boolean,
			default: true,
		},
		isAbsolute: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			style: {},
			initial: false,
			hidden: false,
		};
	},
	computed: {
		el() {
			return this.$refs.container && this.$refs.container.$el
				? this.$refs.container.$el
				: this.$refs.container || null;
		},
	},
	watch: {
		active() {
			this.$nextTick(() => {
				this.layout();
			});
		},
	},
	mounted() {
		this.layout();
		this.initial = true;
		this.$bus.$on('transitionSlideLayout', this.maybeResize);
	},
	created() {
		this.hidden = !this.active;
	},
	beforeDestroy() {
		this.$bus.$off('transitionSlideLayout', this.maybeResize);
	},
	methods: {
		maybeResize() {
			if (this.active && !this.hidden && (!this.isAbsolute || this.$get('el.children'))) {
				this.setHeight(this.getHeight() + 'px', () => this.getHeight() + 'px');
			}
		},
		layout() {
			if (this.active) {
				this.hidden = false;
				this.$emit('open-start');
				if (this.initial) {
					this.setHeight('0px', () => this.getHeight() + 'px');
				}
			} else {
				this.$emit('close-start');
				this.setHeight(this.getHeight() + 'px', () => '0px');
			}
		},
		getHeight() {
			// If we're using absolute positioning, grab
			// the first child and its height.
			if (this.isAbsolute) {
				const firstChild = this.el.children.item(0);

				if (firstChild && firstChild.offsetHeight) {
					return firstChild.offsetHeight;
				}
			}

			return this.$get('el.scrollHeight', 0) || 0;
		},
		asap(callback) {
			if (!this.initial) {
				callback();
			} else {
				this.$nextTick(callback);
			}
		},
		setHeight(temp, afterRelayout) {
			this.style = { height: temp };

			this.asap(() => {
				// force relayout so the animation will run
				this.__ = this.getHeight();

				this.style = {
					'height': afterRelayout(),
					'overflow': 'hidden',
					'transition-property': 'all',
					'transition-duration': this.duration + 'ms',
				};
			});
		},
		onTransitionEnd(event) {
			// Don't do anything if the transition doesn't belong to the container
			if (event.target !== this.el) {
				return;
			}

			if (this.active) {
				if (!this.isAbsolute) {
					this.style = {};
				}
				this.$emit('opened');
			} else {
				this.style = {
					height: '0',
					overflow: 'hidden',
					padding: '0',
					margin: '0',
					border: '0',
				};
				this.hidden = true;
				this.$emit('closed');
			}
		},
	},
};
</script>
